import { QueryClient } from '@tanstack/react-query';

// Sensible defaults — features may override per-query.
// Mutations don't auto-retry to avoid duplicate side effects.

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 min
      gcTime: 5 * 60 * 1000, // 5 min
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
